import React from 'react'
import PropTypes from 'prop-types'
import { useQuery } from 'react-query'
import { Notification } from '@offerzen/pinata'

import JobCard from './JobCard'
import SkeletonJobList from './SkeletonJobList'
import EmptyListCard from './EmptyListCard'
import { fetchRecommendedJobs } from './api'
import styles from './styles'

const JobList = ({ candidateProfileId }) => {
  const { data, isLoading, isError } = useQuery(['recommendedJobs', candidateProfileId], () => fetchRecommendedJobs(candidateProfileId))

  if (isError) {
    return (
      <Notification theme="error">
        <div role="alert">Something went wrong.</div>
      </Notification>
    )
  }

  if (isLoading || !data) return <SkeletonJobList />

  const { recommendedPositionCards } = data

  if (recommendedPositionCards?.nodes.length === 0) return <EmptyListCard />

  return (
    <ul className={styles.list}>
      <For each="job" of={recommendedPositionCards.nodes}>
        <li key={job.id}>
          <JobCard job={job} />
        </li>
      </For>
    </ul>
  )
}

JobList.propTypes = {
  candidateProfileId: PropTypes.string,
}

export default JobList
